import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import { popupAjaxError } from "discourse/lib/ajax-error";
import ComboBoxComponent from "discourse/select-kit/components/combo-box";
import { selectKitOptions } from "discourse/select-kit/components/select-kit";
import { i18n } from "discourse-i18n";

let cache = {};

@selectKitOptions({
  filterable: true,
  fullWidthOnMobile: true,
  clearable: false,
  autoInsertNoneItem: false,
  valueProperty: "slug_path_with_id",
})
export default class NavigationComboBox extends ComboBoxComponent {
  willDestroyElement() {
    super.willDestroyElement(...arguments);
    cache = {};
  }

  async search(filter) {
    const filterType = this.suggestedType;
    const cacheKey = `${filterType}-${filter}`;

    if (this.get("pendingSearch") === cacheKey) {
      return;
    }

    this.set("pendingSearch", cacheKey);

    // check the cache first
    if (cache[cacheKey]) {
      return cache[cacheKey];
    }

    // if no cache was found, perform the search on the backend
    const data = {
      filter,
      ...(!filter && { type: filterType }),
    };

    const store = getOwner(this).lookup("service:store");

    try {
      const response = await store.findAll("circle", data);

      const values = response?.content.map((circle) =>
        this.defaultItem(circle.slug_path_with_id, circle.name)
      );

      if (!filter) {
        values.unshift(
          this.defaultItem(null, i18n("discourse_circles.index.all.title"))
        );
      }

      cache[cacheKey] = values;

      return values;
    } catch (e) {
      popupAjaxError(e);
    } finally {
      this.set("pendingSearch", undefined);
    }
  }

  _defaultItem(circle) {
    return {
      name: circle.name,
      slug_path_with_id: circle.slug_path_with_id,
    };
  }

  @action
  onChange(slug_path_with_id) {
    const router = getOwner(this).lookup("service:router");

    if (slug_path_with_id) {
      router.transitionTo("circle", slug_path_with_id);
    } else {
      // navigate to the list page
      router.transitionTo("circles");
    }
  }
}
